import { Injectable, inject } from '@angular/core';
import { PopupErrorComponent } from '../components/popup-error/popup-error.component';
import { SiModalService } from '@siemens/element-ng/modal';

@Injectable({
    providedIn: 'root'
})
export class PopupDialogService {
    dialog = inject(SiModalService);

    openDialogs: any = {};

    defaultData = {
        data: {
            id: 'maintenance',
            title: 'popup.maintenance.title',
            body: 'popup.maintenance.body'
        },
        class: 'modal-md',
        ignoreBackdropClick: false,
        keyboard: true,
        animated: true
    };

    open(data?: any): void {
        if (data === undefined) {
            data = this.defaultData;
        }
        if (this.openDialogs[data.data.id] === undefined || this.openDialogs[data.data.id] !== true) {
            const id = data.data.id;
            const dialogRef = this.dialog.show(
                PopupErrorComponent,
                {
                    ...data,
                    inputValues: { data: data.data }
                },
                'close'
            );
            this.openDialogs[id] = true;
            dialogRef.hidden.subscribe(() => {
                delete this.openDialogs[id];
            });
        }
    }
}
